import React, { useEffect, useState } from 'react';
import Props from '../types/props';
import DashboardService from '../services/DashboardService';
import SalesDashboardContext from '../context/SalesDashBoardContext';

export default function SalesDashBoardProvider(props: Props) {
  const [DashBoardData, setDashBoardData] = useState({});
  const [loading, setLoading] = useState(true);


  const getDashboardData = async (
    query: string,
    filter: Record<string, unknown>
  ) => {
    try {
      setLoading(true);
      const data = await new DashboardService().fetchUserData(query, filter);
      setLoading(false);
      setDashBoardData(data as any);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    }
  };

  useEffect(() => {
    getDashboardData(`sales/dashboard`, {});
  }, []);

  if (Object.keys(DashBoardData).length === 0) {
    return null; // or any loading indicator if needed
  }

  return (
    <SalesDashboardContext.Provider value={{ DashBoardData, getDashboardData, setLoading,
      loading, }}>
      {props?.children ?? ''}
    </SalesDashboardContext.Provider>
  );
}
